export const remarketingPermissions = {
    VIEW_VEHICLE_GRADE: {
        key: 'remarketing.vehicle.grade.view',
        name: 'View Vehicle Grade',
    },
    VIEW_INTELLIGENCE_DASHBOARD: {
        key: 'remarketing.view.intelligence.dashboard',
        name: 'View Remarketing Intelligence Dashboard',
    },
}
